import { Id } from "@dgs/core";

export const ALL_CONTACT_EMAIL = ["private", "work", "group", "other"] as const;

export type ContactEmailType = (typeof ALL_CONTACT_EMAIL)[number];

export type ContactEmailIndexResource = {
	id: Id;
	email: string;
	type: ContactEmailType;
	isPrimary: boolean;
};

export type ContactEmailUpdateResource = ContactEmailIndexResource;

export type ContactEmailRequest = Omit<ContactEmailIndexResource, "id">;

export type ContactEmailFormState = Omit<ContactEmailUpdateResource, "id">;
